'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewHeader = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewHeader, _Component);

  function NewHeader() {
    (0, _classCallCheck3.default)(this, NewHeader);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewHeader).call(this));
  }

  (0, _createClass3.default)(NewHeader, [{
    key: 'render',
    value: function render() {
      var styles = require('./NewHeader.scss');
      var _props = this.props;
      var isNotBack = _props.isNotBack;
      var isLinkShow = _props.isLinkShow;
      var style = _props.style;

      return _react2.default.createElement(
        'div',
        { className: styles.headerTop, style: style },
        isNotBack ? '' : _react2.default.createElement('div', { className: styles.headerBack }),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/', className: styles.headerLogoTop },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/header/logo.png', alt: '' })
        ),
        isLinkShow ? _react2.default.createElement(
          'div',
          { className: styles.headerGymsTop },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/customproductslist' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/main/gzzbg1.jpg',
              alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/home' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/main/gzzbg2.jpg', alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/servicesmarket' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/main/gzzbg3.jpg',
              alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: 'http://baike.craftschina.cn/', target: '_blank' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/main/gzzbg4.jpg', alt: '' })
          )
        ) : ''
      );
    }
  }]);
  return NewHeader;
}(_react.Component), _class.propTypes = {
  isNotBack: _react.PropTypes.bool,
  isLinkShow: _react.PropTypes.bool,
  style: _react.PropTypes.object
}, _temp);
exports.default = NewHeader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewHeader/NewHeader.js
 ** module id = 1376
 ** module chunks = 0
 **/